import { Box, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { getServicePageRoute } from "../../../../routers/routeUtils";

import { Service } from "../../types/service.type";
import { ServiceTypeEnum } from "../../enum/service.enum";

import { ProgramCard } from "../ProgramCard";

import ServiceCardBody from "./ServiceCardBody";
import ServiceCardHeader from "./ServiceCardHeader";
import ServiceCardFooter from "./ServiceCardFooter";
import ServiceCardLoader from "./ServiceCardLoader";

const ServiceCard = ({ service, width = "390px" }: { service: Service; width?: string }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(getServicePageRoute(service.id, service.type));
  };

  const isProgram = service.type === ServiceTypeEnum.Program;

  if (isProgram) return <ProgramCard service={service} width={width} />;

  return (
    <Box onClick={handleCardClick} sx={styles.container(width)}>
      <ServiceCardHeader service={service} />
      <ServiceCardBody service={service} />
      <Divider orientation="horizontal" sx={{ borderColor: "var(--Gray-200, #EAECF0)" }} />
      <ServiceCardFooter service={service} />
    </Box>
  );
};

export { ServiceCard, ServiceCardLoader };

const styles = {
  container: (width: string) => ({
    width: { xs: "100%", md: width },
    height: "430px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    borderRadius: "8px",
    border: "1px solid #D2D7DF",
    boxShadow: "0px 12px 20px 0px rgba(0, 0, 0, 0.04), 0px 0px 2px 0px rgba(0, 0, 0, 0.06)",
    overflow: "hidden",
    flexShrink: 0,
    cursor: "pointer",
    transition: "box-shadow 0.2s ease-in-out",
    "&:hover": {
      boxShadow: "0px 16px 24px 0px rgba(0, 0, 0, 0.1), 0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    },
  }),
};
